import { render, staticRenderFns } from "./TeamBody.vue?vue&type=template&id=05a8d737&scoped=true&"
import script from "./TeamBody.vue?vue&type=script&lang=js&"
export * from "./TeamBody.vue?vue&type=script&lang=js&"
import style0 from "./TeamBody.vue?vue&type=style&index=0&id=05a8d737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a8d737",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a8d737')) {
      api.createRecord('05a8d737', component.options)
    } else {
      api.reload('05a8d737', component.options)
    }
    module.hot.accept("./TeamBody.vue?vue&type=template&id=05a8d737&scoped=true&", function () {
      api.rerender('05a8d737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/Team/TeamBody.vue"
export default component.exports